import Select from "@mui/material/Select";
import { styled } from "@mui/system";

const StyledSelect = styled(Select)(() => ({
  "&&": {
    width: "100%",
    height: "56px",
    minHeight: "56px",
    color: "#000000",
    background: "#ffffff",
    borderRadius: "5px",
    fontSize: "1rem",
    fontWeight: 400,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ced4da",
    borderWidth: "1px",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ced4da",
    borderWidth: "1px",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ced4da",
    borderWidth: "1px",
  },
  "&&.Mui-disabled": {
    opacity: 0.75,
    cursor: "not-allowed",
    backgroundColor: "#ffffff",
    pointerEvents: "auto",
  },
  "&&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ced4da",
    borderWidth: "1px",
  },
}));

export default StyledSelect;
